window.theme = window.theme || {};

theme.inlineNavigationCheck = function () {
  var pageHeader = document.querySelector('.pageheader');
  if (!pageHeader) return;

  var inlineNavContainer = pageHeader.querySelector('.logo-area__left__inner');
  if (!inlineNavContainer) return;

  var inlineNav = inlineNavContainer.querySelector('.navigation--left');
  if (!inlineNav || getComputedStyle(inlineNav).display === 'none') return;

  var inlineMenuCentered = document.querySelector('.pageheader--layout-inline-menu-center');
  var logoContainer = document.querySelector('.logo-area__middle__inner');

  if (inlineMenuCentered && logoContainer) {
    var rightWidth = document.querySelector('.logo-area__right__inner').clientWidth;
    var middleWidth = logoContainer.clientWidth;
    var logoArea = document.querySelector('.logo-area');
    var computedLogoAreaStyle = getComputedStyle(logoArea);
    var logoAreaInnerWidth = logoArea.clientWidth - Math.ceil(parseFloat(computedLogoAreaStyle.paddingLeft)) - Math.ceil(parseFloat(computedLogoAreaStyle.paddingRight));
    var availableNavWidth = logoAreaInnerWidth - Math.max(rightWidth, middleWidth) * 2 - 40;
    inlineNavContainer.style.maxWidth = availableNavWidth + 'px';
  }

  var firstInlineNavLink = inlineNav.querySelector('.navigation__item:first-child');
  var lastInlineNavLink = inlineNav.querySelector('.navigation__item:last-child');
  if (!lastInlineNavLink || !logoContainer) return;

  var inlineNavWidth;
  if (document.querySelector('html[dir=rtl]')) {
    inlineNavWidth = firstInlineNavLink.offsetLeft - lastInlineNavLink.offsetLeft + firstInlineNavLink.offsetWidth;
  } else {
    inlineNavWidth = lastInlineNavLink.offsetLeft - firstInlineNavLink.offsetLeft + lastInlineNavLink.offsetWidth;
  }

  if (inlineNavContainer.offsetWidth >= inlineNavWidth) {
    pageHeader.classList.add('pageheader--layout-inline-permitted');
    var tallLogo = logoContainer.clientHeight > lastInlineNavLink.clientHeight + 20;
    inlineNav.classList.toggle('navigation--tight-underline', tallLogo);
  } else {
    pageHeader.classList.remove('pageheader--layout-inline-permitted');
  }
};

theme.setInitialHeaderHeightProperty = function () {
  var section = document.querySelector('.section-header');
  if (section) {
    document.documentElement.style.setProperty('--theme-header-height', Math.ceil(section.clientHeight) + 'px');
  }
};

(function () {
  var gaChannel = new MessageChannel();
  window.gaPort = gaChannel.port2;
  window.gaPort.start();

  var discount = new URLSearchParams(location.search).get('discount');
  if (discount != null) {
    window.sessionStorage.setItem('additionalDiscount', discount);
  }
})();
